import script from "./industryLink.vue?vue&type=script&setup=true&lang=js"
export * from "./industryLink.vue?vue&type=script&setup=true&lang=js"

import "./industryLink.vue?vue&type=style&index=0&id=25941c50&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25941c50"]])

export default __exports__